import {
  AllAmenitiesViewModel,
  AmenityViewModel,
  HighlightAmenitiesViewModel,
  PropertyAdditionalInfoViewModel,
  PropertyInfoSectionViewModel,
  PropertyInfoSubSectionViewModel
} from 'models';

export function hasAmenities(propertyInfo: any) {
  return propertyInfo.summary?.amenities;
}

export function adaptAmenities(amenities: any): AllAmenitiesViewModel {
  return {
    topSummary: adaptAmenityViewModel(amenities.top),
    highlightAmenities: adaptHighlightAmenities(amenities.takeover.highlight)
  } as AllAmenitiesViewModel;
}

export function adaptAmenityViewModel(amenities: any): AmenityViewModel[] {
  return amenities.map(
    amenity =>
      ({
        description: amenity.text,
        category: amenity.icon.id
      } as AmenityViewModel)
  );
}

export function adaptHighlightAmenities(highlightAmenities): HighlightAmenitiesViewModel[] {
  return highlightAmenities.map(
    amenity =>
      ({
        label: '',
        sections: adaptAmenityViewModel(amenity.items),
        title: amenity.heading
      } as HighlightAmenitiesViewModel)
  );
}

export function updateAdditionalInfo(additionalInfo: any, amenities: any): PropertyAdditionalInfoViewModel {
  if (!amenities) {
    return additionalInfo;
  }
  const [propertyAmenities, roomAmenities] = amenities;
  additionalInfo.propertyAmenitiesSection = propertyAmenities
    ? adaptPropertyInfoSectionViewModel(propertyAmenities)
    : additionalInfo.propertyAmenitiesSection;
  additionalInfo.roomAmenitiesSection = roomAmenities
    ? adaptPropertyInfoSectionViewModel(roomAmenities)
    : additionalInfo.roomAmenitiesSection;

  return additionalInfo;
}

export function adaptPropertyInfoSectionViewModel(section: any): PropertyInfoSectionViewModel {
  return {
    title: section.title,
    sections: adaptPropertyInfoSubSectionViewModel(section.contents)
  } as PropertyInfoSectionViewModel;
}

export function adaptPropertyInfoSubSectionViewModel(subSections: any): PropertyInfoSubSectionViewModel[] {
  return subSections.map(subSection => {
    const description = subSection.items.map(item => item.text);

    return {
      title: subSection.heading,
      icon: subSection.icon.id,
      body: description,
      descriptions: description
    } as PropertyInfoSubSectionViewModel;
  });
}
